import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import PropLibrary from "../prop_library/PropLibrary";
import { EditorColumnFooterButton } from "../editor_columns/EditorColumn";

import {
  selectIsPropLibraryOpen,
  setIsPropLibraryOpen,
} from "../../app/slices/GlobalSlice";
import PropPresetList from "./PropPresetList";
import PresetColumnHeader from "../editor_columns/PresetColumnHeader";
import {
  selectAllPropPresets,
  selectSelectedPropPresetId,
  setSelectedPropPreset,
} from "../../app/slices/TrainingSlice";

/** The prop list, with "Add prop" anchored in a footer like the Storyboard's "Add take". */
export default function PropPresetsColumn() {
  const isOpen = useSelector(selectIsPropLibraryOpen);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const props = useSelector(selectAllPropPresets);
  const selectedPropId = useSelector(selectSelectedPropPresetId);
  const [search, setSearch] = useState("");

  // Opening the tab (or deleting the selected prop) selects the first prop, so the editor never sits empty.
  // Selection is a session action: it does not dirty the training or add an undo step.
  useEffect(() => {
    if (!props?.length) return;
    if (props.some((prop) => prop.id === selectedPropId)) return;
    dispatch(setSelectedPropPreset(props[0].id));
  }, [dispatch, props, selectedPropId]);

  // Adding happens inside the prop library itself now (PropLibraryBody);
  // this column only opens and closes the dialog.

  return (
    <div className={"w-full h-full flex flex-col"}>
      <PresetColumnHeader
        icon={<Inventory2OutlinedIcon fontSize="inherit" />}
        title={String(t("props"))}
        searchPlaceholder={String(t("preset_lists.search_props"))}
        search={search}
        onSearchChange={setSearch}
        testId="prop-presets-header"
      />
      <div className="min-h-0 flex-1 overflow-hidden">
        <PropPresetList search={search} />
      </div>
      <div className="flex-shrink-0 p-2.5 border-t border-creator-border">
        <EditorColumnFooterButton
          label={String(t("prop_list.add_prop"))}
          onClick={() => {
            dispatch(setIsPropLibraryOpen({ open: true, positionId: "" }));
          }}
          testId="prop-presets-add-prop"
        />
      </div>
      <PropLibrary
        title={"Prop Library"}
        isOpen={isOpen}
        onClose={() =>
          dispatch(setIsPropLibraryOpen({ open: false, positionId: "" }))
        }
      />
    </div>
  );
}
